var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4167 12.5H8.75002C8.25002 12.5 7.91669 12.1666 7.91669 11.6666V9.49996C7.91669 8.99996 8.25002 8.66663 8.75002 8.66663C9.25002 8.66663 9.58335 8.99996 9.58335 9.49996V10.8333H10.5834V9.58329C10.5834 9.08329 10.9167 8.74996 11.4167 8.74996C11.9167 8.74996 12.25 9.08329 12.25 9.58329V11.6666C12.25 12.1666 11.8334 12.5 11.4167 12.5Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4167 16.5833H11.1667C10.6667 16.5833 10.3334 16.25 10.3334 15.75C10.3334 15.25 10.6667 14.9166 11.1667 14.9166H14.4167C14.9167 14.9166 15.25 15.25 15.25 15.75C15.25 16.25 14.9167 16.5833 14.4167 16.5833Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 18.25C12.3334 18.25 12.0001 17.9166 12.0001 17.4166V14.1666C12.0001 13.6666 12.3334 13.3333 12.8334 13.3333C13.3334 13.3333 13.6667 13.6666 13.6667 14.1666V17.4166C13.6667 17.8333 13.2501 18.25 12.8334 18.25Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4167 16.5833H11.1667C10.6667 16.5833 10.3334 16.25 10.3334 15.75C10.3334 15.25 10.6667 14.9166 11.1667 14.9166H14.4167C14.9167 14.9166 15.25 15.25 15.25 15.75C15.25 16.25 14.9167 16.5833 14.4167 16.5833Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 18.25C12.3334 18.25 12.0001 17.9166 12.0001 17.4166V14.1666C12.0001 13.6666 12.3334 13.3333 12.8334 13.3333C13.3334 13.3333 13.6667 13.6666 13.6667 14.1666V17.4166C13.6667 17.8333 13.2501 18.25 12.8334 18.25Z",
    fill: "#3A2CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 5.16665C8.08339 5.16665 6.75006 4.66665 6.66672 4.66665C6.16672 4.49998 6.00006 4.08331 6.08339 3.66665C6.25006 3.24998 6.66672 2.99998 7.16672 3.16665C7.25006 3.16665 9.91672 4.08331 13.0001 3.16665C13.4167 2.99998 13.9167 3.24998 14.0001 3.74998C14.1667 4.16665 13.9167 4.66665 13.4167 4.74998C12.2501 5.08331 11.0834 5.16665 10.0834 5.16665Z",
    fill: "#FF9A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 19.5833C16.3333 19.5833 16 19.25 16 18.75V16C16 12.9166 14 12.5 12.8333 12.5H7.33333C6.16667 12.5 4.16667 13 4.16667 16V18.75C4.16667 19.25 3.83333 19.5833 3.33333 19.5833C2.83333 19.5833 2.5 19.25 2.5 18.75V16C2.5 12.1666 5 10.8333 7.33333 10.8333H12.8333C15.1667 10.8333 17.6667 12.1666 17.6667 16V18.75C17.6667 19.25 17.25 19.5833 16.8333 19.5833Z",
    fill: "#FF9A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 10.4166C7.41661 10.4166 5.24994 8.24998 5.24994 5.58331C5.24994 2.91665 7.41661 0.833313 10.0833 0.833313C12.7499 0.833313 14.9166 2.99998 14.9166 5.66665C14.9166 8.33331 12.7499 10.4166 10.0833 10.4166ZM10.0833 2.49998C8.33327 2.49998 6.91661 3.91665 6.91661 5.66665C6.91661 7.41665 8.33327 8.74998 10.0833 8.74998C11.8333 8.74998 13.2499 7.33331 13.2499 5.58331C13.2499 3.83331 11.8333 2.49998 10.0833 2.49998Z",
    fill: "#FF9A7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1667,
    height: 18.75,
    fill: "white",
    transform: "translate(2.5 0.833313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertical);
export default __webpack_public_path__ + "static/media/vertical.e724d1b8a9fb63fab8b6052713c14a44.svg";
export { ForwardRef as ReactComponent };